/**
 *
 * CreateGroup
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import GroupForm from './GroupForm';
import createSession from './createSession';
import getTempId from './getTempId';

function CreateGroup(props) {
  const { onSubmit } = props;
  const handleSubmit = data => {
    const body = {
      name: data.name,
      schedule: Object.values(data.schedule),
    };
    onSubmit({
      method: 'POST',
      url: '/res/groups',
      body,
      // A retry after a lost response would create the group twice
      retry: false,
    });
  };
  const group = {
    name: '',
    schedule: { [getTempId()]: createSession() },
  };
  return <GroupForm group={group} onSubmit={handleSubmit} />;
}

CreateGroup.propTypes = {
  onSubmit: PropTypes.func,
};

export default CreateGroup;
